'use client';

import React from 'react';
import {usePathname} from 'next/navigation';
import {GA_TRACKING_ID} from '@utils/googleAnalytics';
import {GoogleTagManager as NxtGoogleTagName} from '@next/third-parties/google';
import { trackPageView } from '@utils/googleAnalytics/googleAnalyticsEvents';

const GoogleAnalytics = () => {
  const pathname = usePathname();

  React.useEffect(() => {
    trackPageView();
    return () => {};
  }, [pathname]);

  return (
    <>
      <NxtGoogleTagName gtmId={GA_TRACKING_ID as string} />
    </>
  );
};

export default GoogleAnalytics;
